'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { Button } from '@repo/design-system/components/ds/button';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useT } from '@repo/i18n/components/i18n.client';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectTitleId, selectTitleName } from '@repo/store/maps/slices/mapData';
import { HostType } from '@repo/types/host';
import { Link } from '@repo/ui/components/link/link';
export const MapTopBarActions = t0 => {
  const $ = _c(16);
  const {
    downloadButtonText,
    downloadPath
  } = t0;
  const hostType = useHostType();
  const analytics = useAnalytics();
  const externalMapId = useAppSelector(selectExternalMapId);
  const titleId = useAppSelector(selectTitleId);
  const titleName = useAppSelector(selectTitleName);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["common"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  if (hostType !== HostType.WEB) {
    return null;
  }
  let t2;
  if ($[1] !== analytics || $[2] !== externalMapId || $[3] !== hostType || $[4] !== titleId || $[5] !== titleName) {
    t2 = () => {
      analytics.event("game_map_web_download_wemod_click", {
        mapId: externalMapId ?? "",
        titleId: titleId ?? "",
        titleName: titleName ?? "",
        platform: hostType
      });
    };
    $[1] = analytics;
    $[2] = externalMapId;
    $[3] = hostType;
    $[4] = titleId;
    $[5] = titleName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleClick = t2;
  let t3;
  if ($[7] !== downloadButtonText || $[8] !== t) {
    t3 = downloadButtonText || t(_temp);
    $[7] = downloadButtonText;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <Button color="white">{t3}</Button>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== downloadPath || $[13] !== handleClick || $[14] !== t4) {
    t5 = <Link href={downloadPath} onClick={handleClick}>{t4}</Link>;
    $[12] = downloadPath;
    $[13] = handleClick;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp($) {
  return $.download_wand;
}